/*eslint-disable no-throw-literal*/
import axios, { AxiosRequestConfig } from 'axios';
import { v4 as uuidv4 } from 'uuid';
import keycloak from '../Keycloak';
import { configApi } from '../config';

export const api = axios.create({
    baseURL: configApi.rubricae.url,
    headers: {
        'Content-Type': 'application/json;charset=UTF-8'
    }
});

api.interceptors.request.use((config: AxiosRequestConfig) => {
    if (config.headers) {
        config.headers.authorization = `Bearer ${keycloak.token}`;
        config.headers['x-correlation-id'] = uuidv4();
    }
    return config;
});

const buildRubricaeApiError = (errorData: any, details: any) => {
    const code = errorData?.code ?? errorData ?? 1000;
    const message = errorData?.message ?? errorData ?? '1000';
    return {
        code: String(code),
        message: String(message),
        details
    };
};

api.interceptors.response.use(
    async (response) => {
        return response;
    },
    (error: any) => {
        if (axios.isCancel(error) || error?.code === 'ERR_CANCELED') {
            return Promise.reject(error);
        }

        console.error(`Error on API call:`);
        console.error({
            method: error.config?.method,
            url: error.config?.url,
            data: error.config?.data,
            headers: error.config?.headers
        });

        if (!error.response) {
            throw buildRubricaeApiError(1000, error);
        }

        let errorData = error.response.data;

        if (error.response.config.responseType === 'arraybuffer') {
            const decodedDataBuffer = String.fromCharCode.apply(null, new Uint8Array(error.response.data) as any);
            try {
                errorData = JSON.parse(decodedDataBuffer);
            } catch {
                errorData = { code: '1000', message: '1000' };
            }
        }

        if (error.response.status === 400) {
            throw buildRubricaeApiError(errorData, error);
        }

        if (error.response.status === 401) {
            return keycloak.logout();
        }

        if (error.response.status === 403) {
            throw { code: 404, message: 'SERVICIO_NO_ACTIVO', details: error };
        }

        if (error.response.status === 404 || errorData === 1002) {
            throw { code: 404, message: '1000' };
        }

        throw buildRubricaeApiError(errorData, error);
    }
);
